import React from 'react';
import { SnackbarProvider } from 'notistack';
import './App.css';
import AppRouter from './Routes';
import { Store } from './Store';
import { ToastProvider } from 'react-toast-notifications';
import { UploadProvider } from './contexts';
function App() {
  return (
    <Store>
      <ToastProvider>
        <UploadProvider>
          <SnackbarProvider maxSnack={3} preventDuplicate>
            <AppRouter />
          </SnackbarProvider>
        </UploadProvider>
      </ToastProvider>
    </Store>
  );
}

export default App;
